import React, { useEffect, useMemo, useState } from "react";
import { Clock, BarChart, Monitor, Users, Globe, Home } from "lucide-react";
import i18n from "../../i18n";

const OffersSection = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const tr = useMemo(() => {
    void langTick;

    return {
      title: i18n.t("offersSection.title"),
      items: [
        {
          icon: <Clock size={28} />,
          title: i18n.t("offersSection.items.0.title"),
          description: i18n.t("offersSection.items.0.description"),
        },
        {
          icon: <BarChart size={28} />,
          title: i18n.t("offersSection.items.1.title"),
          description: i18n.t("offersSection.items.1.description"),
        },
        {
          icon: <Monitor size={28} />,
          title: i18n.t("offersSection.items.2.title"),
          description: i18n.t("offersSection.items.2.description"),
        },
        {
          icon: <Users size={28} />,
          title: i18n.t("offersSection.items.3.title"),
          description: i18n.t("offersSection.items.3.description"),
        },
        {
          icon: <Globe size={28} />,
          title: i18n.t("offersSection.items.4.title"),
          description: i18n.t("offersSection.items.4.description"),
        },
        {
          icon: <Home size={28} />,
          title: i18n.t("offersSection.items.5.title"),
          description: i18n.t("offersSection.items.5.description"),
        },
      ],
    };
  }, [langTick]);

  return (
    <div className="bg-gray-100 text-black py-16 px-8 flex flex-col items-center">
      <h2 className="mt-16 text-4xl font-sb mb-12 text-gray-700">
        {tr.title}
      </h2>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-16 max-w-5xl w-full mb-20">
        {tr.items.map((offer, index) => (
          <div
            key={index}
            className="flex flex-col items-start text-left space-y-2 transform transition-transform duration-300 hover:scale-105"
          >
            <div className="bg-indigo-100 p-4 rounded-full mb-4">
              <div className="text-indigo-500 text-2xl">
                {offer.icon}
              </div>
            </div>

            <h3 className="text-lg font-semibold">{offer.title}</h3>
            <p className="text-gray-600 text-sm">{offer.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OffersSection;


